import { FlaskConical, Package, Users, UserCheck } from "lucide-react";
import CountUp from "react-countup";
import { motion } from "framer-motion";

export default function Stats() {
  const stats = [
    { icon: <FlaskConical className="w-10 h-10 mb-3 text-green-400" />, value: 55, label: "API & Intermediates", suffix: "+" },
    { icon: <Package className="w-10 h-10 mb-3 text-yellow-400" />, value: 115, label: "Formulation Products", suffix: "+" },
    { icon: <Users className="w-10 h-10 mb-3 text-teal-400" />, value: 100, label: "Customers", suffix: "+" },
    { icon: <UserCheck className="w-10 h-10 mb-3 text-orange-400" />, value: 200, label: "Employees", suffix: "+" },
  ];

  return (
    <section className="relative bg-blue-900 py-20 overflow-hidden">
      {/* Background World Map */}
      <div className="absolute inset-0">
        <img
          src="/images/world-map-dots.webp"
          alt="World Map"
          className="w-full h-full object-cover opacity-10"
        />
      </div>

      {/* Content Wrapper */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center">
        
        {/* Section Heading */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-3xl md:text-4xl font-bold text-white mb-4"
        >
          Our Global Presence
        </motion.h2>

        {/* Tagline */}
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-blue-200 mb-12 max-w-2xl mx-auto"
        >
          Delivering innovation, quality, and trust across international markets.
        </motion.p>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 text-white gap-12 px-6">
          {stats.map((stat, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.2 }}
              className="flex flex-col items-center"
            >
              {stat.icon}
              <h3 className="text-3xl font-bold">
                <CountUp end={stat.value} duration={2} />{stat.suffix}
              </h3>
              <p className="uppercase tracking-wide text-sm mt-1">{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
